import z from 'zod';

import {
  BaseReferenceDto,
  PlanResourceReference,
  SearchDocument,
} from '@/_generated/api-clients/xp';

export const isPlanResourceReference = (
  reference: BaseReferenceDto,
): reference is PlanResourceReference =>
  z
    .object({
      urls: z.array(z.unknown()),
    })
    .safeParse(reference).success;

export const mapReferenceToDocument = (
  reference: PlanResourceReference,
): SearchDocument => {
  const primaryUrl = reference.urls.at(0);

  return {
    contentApiUrl: primaryUrl?.contentApiUrl,
    contentUrl: primaryUrl?.contentUrl,
    icon: undefined,
    id: reference.id,
    lastModified: reference.updatedAt,
    name: reference.name,
    otherContentUrl: undefined,
    otherName: undefined,
    otherPrintUrl: undefined,
    printUrl: primaryUrl?.printUrl ?? undefined,
    searchId: '',
    sourceSystem: reference.sourceSystem as SearchDocument['sourceSystem'],
    tags: reference.tags,
    type: reference.format as SearchDocument['type'],
  };
};
